import { ColorVariantsDisplayType } from '../../../app-state-types/reducer-state-types/add-to-cart/color-variants-display-type';

export const colorVariantsTypes = [
  { value: ColorVariantsDisplayType.grid, label: 'Grid' },
  { value: ColorVariantsDisplayType.slider, label: 'Slider' },
];
